import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { AuthenticationService } from "../../../auth/service";
import { UtilsService } from "../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { FlatpickrOptions } from "ng2-flatpickr";
import Italian from "flatpickr/dist/l10n/it";
import { IContentHeader } from "../../../layout/components/content-header/content-header.component";
import moment from "moment";
import { HttpClient } from "@angular/common/http";
import { catchError, tap, timeout } from "rxjs/operators";

@Component({
  selector: "app-platform-management",
  templateUrl: "./platform-management.component.html",
  styleUrls: ["./platform-management.component.scss"]
})
export class PlatformManagementComponent implements OnInit {
  public contentHeader: IContentHeader;
  public formGroup: FormGroup;
  public optionFrom: FlatpickrOptions;
  public optionTo: FlatpickrOptions;
  public pages: any = {};
  public urlClearCache: string = null;
  public isSubmitting: boolean = false;
  @ViewChild("refreshAnalytics") refreshAnalytics: ElementRef;
  @ViewChild("setAMaintenance") setAMaintenance: ElementRef;
  @ViewChild("clearCache") clearCache: ElementRef;
  @ViewChild("generateInvoiceModal") generateInvoiceModal: ElementRef;
  public regenerateInvoiceMonth: number = moment().get("months") + 1;
  public currentYear: any = moment().get("years");
  public lastMonths: any = [];
  public currentMonth: number = moment().get("months") + 1;
  public searchFeaturOption: string = "";

  monthToReload: number = moment().month() + 1;
  months = moment.months();
  yearToReload: number = moment().year();


  constructor(
    public _authService: AuthenticationService,
    public _utilsService: UtilsService,
    public _modalService: NgbModal,
    public _formBuilder: FormBuilder,
    private _httpClient: HttpClient
  ) {
    this.contentHeader = {
      headerTitle: "PLATFORM_MANAGEMENT",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "PLATFORM_MANAGEMENT",
            isLink: false
          }
        ]
      }
    };
    this.formGroup = this._formBuilder.group({
      day_from: new FormControl("", [Validators.required, Validators.pattern("^\\d{4}\\-(0?[1-9]|1[012])\\-(0?[1-9]|[12][0-9]|3[01])$")]),
      day_to: new FormControl("", [Validators.required, Validators.pattern("^\\d{4}\\-(0?[1-9]|1[012])\\-(0?[1-9]|[12][0-9]|3[01])$")]),
      hour_from: new FormControl(
        {
          hour: 9,
          minute: 0
        },
        [Validators.required, Validators.minLength(2), Validators.maxLength(2)]
      ),
      hour_to: new FormControl(
        {
          hour: 10,
          minute: 0
        },
        [Validators.required, Validators.minLength(2), Validators.maxLength(2)]
      )
    });

    this.pages.update_data = [];
    this.pages.administration = [];
    this.pages.lists = [];
    this.pages.invoice = [];
    this.pages.user_permissions = [];

    for (const page of this._utilsService.themeConfiguration.settings_pages) {
      if (!Object.keys(this.pages).includes(page.section)) {
        this.pages[page.section] = [];
      }

      if (this._authService.hasCapability(page.capability)) {
        this.pages[page.section].push({
          label: page.label,
          url: page.url
        });
      }
    }

    if (this._authService.hasCapability("show_menu_payroll")) {
      this.pages.update_data.push({
        label: "MENU.PAYROLLS",
        url: "/dashboard/payroll"
      });
    }

    if (this._authService.hasCapability("view_residual_absences_list")) {
      this.pages.update_data.push({
        label: "MENU.LIST_RESIDUAL_ABSENCES",
        url: "/dashboard/list-residual-absences"
      });
    }

    if (this._authService.hasCapability("create_commission_analytics_monthly")) {
      this.pages.update_data.push({
        label: "MENU.REFRESH_MONTHLY_ANALYTICS",
        click: () => this.modalOpen(this.refreshAnalytics)
      });
    }

    if (this._authService.hasCapability("show_menu_absences_types_list")) {
      this.pages.update_data.push({
        label: "MENU.ABSENCES_TYPE",
        url: "/dashboard/absences-type-list"
      });
    }

    if (this._authService.hasCapability("show_menu_contracts_costs_list")) {
      this.pages.update_data.push({
        label: "MENU.CONTRACTS_COSTS",
        url: "/dashboard/gestione/costi-contratti/list"
      });
    }

    if (this._authService.hasCapability("create_absence_for_others")) {
      this.pages.update_data.push({
        label: "ADD_ABSENCE_EMPLOYEE",
        click: () => this._utilsService.toggleAbsencePopup("addAbsence")
      });
    }

    if (this._authService.hasCapability("show_menu_requested_refunds")) {
      this.pages.administration.push({
        label: "MENU.REFUNDS_REQUESTED_LIST",
        url: "/dashboard/refunds/requested"
      });
    }

    if (this._authService.hasCapability("show_menu_refunds_kilometers")) {
      this.pages.administration.push({
        label: "MENU.REFUND_KM",
        url: "/dashboard/refunds/user-list-refund"
      });
    }

    if (this._authService.hasCapability("view_others_absences")) {
      this.pages.administration.push({
        label: "MENU.ABESENCES_REQUESTED_LIST",
        url: "/dashboard/absence/requested-list"
      });
    }

    if (this._authService.hasCapability("get_contracts_template")) {
      this.pages.administration.push({
        label: "MENU.MANAGE_CONTRACT",
        url: "/dashboard/manager-contract"
      });
    }
    if (this._authService.hasCapability("show_menu_contracts_costs_list")) {
      this.pages.administration.push({
        label: "MENU.SIMULATION_CONTRACT_COSTS",
        url: "/dashboard/gestione/costi-contratti/detailed-list"
      });
    }

    if (this._authService.hasCapability("show_customer_stats")) {
      this.pages.administration.push({
        label: "MENU.STATS_CLIENT",
        url: "/dashboard/customers/stats"
      });
    }
    if (this._authService.hasCapability("show_customer_stats")) {
      this.pages.administration.push({
        label: "MENU.SEND_MULTIPLE_WELCOME_EMAIL",
        url: "/dashboard/send-multiple-welcome-email"
      });
    }
    if (this._authService.hasCapability("show_menu_causal_list")) {
      this.pages.lists.push({
        label: "MENU.CAUSALS",
        url: "/dashboard/causals"
      });
    }
    if (this._authService.hasCapability("show_menu_cities_list")) {
      this.pages.lists.push({
        label: "MENU.CITIES",
        url: "/dashboard/cities"
      });
    }
    if (this._authService.hasCapability("show_company_office_list")) {
      this.pages.lists.push({
        label: "MENU.COMPANY_OFFICES",
        url: "/dashboard/company-office-list"
      });
    }
    if (this._authService.hasCapability("show_menu_certifications_list")) {
      this.pages.lists.push({
        label: "CERTIFICATIONS",
        url: "/dashboard/certifications"
      });
    }
    if (this._authService.hasCapability("show_menu_education_titles_list")) {
      this.pages.lists.push({
        label: "EDUCATION_TITLE",
        url: "/dashboard/education-titles"
      });
    }
    if (this._authService.hasCapability("show_menu_education_subject_list")) {
      this.pages.lists.push({
        label: "SCHOOL",
        url: "/dashboard/education-subject"
      });
    }
    if (this._authService.hasCapability("show_menu_user_figure_list")) {
      this.pages.lists.push({
        label: "MENU.FIGURES",
        url: "/dashboard/figures"
      });
    }
    if (this._authService.hasCapability("show_menu_skills_list")) {
      this.pages.lists.push({
        label: "SKILLS",
        url: "/dashboard/skills"
      });
    }
    if (this._authService.hasCapability("view_domain_list")) {
      this.pages.lists.push({
        label: "MENU.DOMAIN",
        url: "/dashboard/domain-list"
      });
    }
    if (this._authService.hasCapability("view_tutorial_list")) {
      this.pages.lists.push({
        label: "MENU.TUTORIAL",
        url: "/dashboard/tutorial-list"
      });
    }
    if (this._authService.hasCapability("show_field_database_list")) {
      this.pages.lists.push({
        label: "MENU.FIELDS_DB",
        url: "/dashboard/fields-db-list"
      });
    }
    if (this._authService.hasCapability("view_shortlink_list")) {
      this.pages.lists.push({
        label: "MENU.SHORTLINKS",
        url: "/dashboard/short-links"
      });
    }

    if (this._authService.hasCapability("task_view_others")) {
      this.pages.lists.push({
        label: "ALL_LIST_TODO",
        url: "/dashboard/todo/all-list"
      });
    }

    if (this._authService.hasCapability("show_menu_capabilities_list")) {
      this.pages.user_permissions.push({
        label: "MENU.CAPABILITIES_LIST",
        url: "/dashboard/capability/list"
      });
    }
    if (this._authService.hasCapability("show_menu_capabilities_add")) {
      this.pages.user_permissions.push({
        label: "MENU.ADD_CAPABILITIES",
        url: "/dashboard/capability/add"
      });
    }
    if (this._authService.hasCapability("show_menu_capabilities_assign")) {
      this.pages.user_permissions.push({
        label: "MENU.ASSIGN_CAPABILITIES",
        url: "/dashboard/capability/assign"
      });
    }
    if (this._authService.hasCapability("show_menu_capabilities_roles_list")) {
      this.pages.user_permissions.push({
        label: "MENU.ROLES",
        url: "/dashboard/capability/roles"
      });
    }

    this.pages.documents = [];
    if (this._authService.hasCapability("show_categories_documents")) {
      this.pages.documents.push({
        label: "CATEGORIES",
        url: "/dashboard/documents-categories"
      });
    }
    if (this._authService.hasCapability("show_menu_documents_list")) {
      this.pages.documents.push({
        label: "DOCUMENTS_ARCHIVE",
        url: "/dashboard/documents-list"
      });
    }
    if (this._authService.hasCapability("create_document")) {
      this.pages.documents.push({
        label: "MENU.DOCUMENTS_SEND",
        url: "/dashboard/documents-send"
      });
    }
    if (this._authService.hasCapability("show_menu_documents_template_list")) {
      this.pages.documents.push({
        label: "MENU.DOCUMENT_TEMPLATE_LIST",
        url: "/dashboard/documents-list-template"
      });
    }
    if (this._authService.hasCapability("create_document_template")) {
      this.pages.documents.push({
        label: "MENU.ADD_FORM_TEMPLATE",
        url: "/dashboard/documents-form-template"
      });
    }
    if (this._authService.hasCapability("view_document_template_employee_list")) {
      this.pages.documents.push({
        label: "MENU.TEMPLATE_USER_LIST",
        url: "/dashboard/documents/document-to-user"
      });
    }

    this.pages.notifications = [];
    if (this._authService.hasCapability("show_all_notifications_list")) {
      this.pages.notifications.push({
        label: "MENU.LIST_NOTIFICATIONS",
        url: "/dashboard/communications-list"
      });
    }
    if (this._authService.hasCapability("show_notification_categories_list")) {
      this.pages.notifications.push({
        label: "MENU.CATEGORIES_NOTIFICATIONS",
        url: "/dashboard/category-communications"
      });
    }
    if (this._authService.hasCapability("show_communications_send")) {
      this.pages.notifications.push({
        label: "MENU.SEND_COMMUNICATION",
        url: "/dashboard/send-communication"
      });
    }

    this.pages.manage_platform = [];
    if (this._authService.hasCapability("manage_platform_maintenance")) {
      this.pages.manage_platform.push({
        label: "SET_A_MAINTENANCE",
        click: () => this.modalOpen(this.setAMaintenance)
      });
    }
    if (this._authService.hasCapability("manage_platform_cache")) {
      this.pages.manage_platform.push({
        label: "CLEAR_CACHE",
        click: () => this.modalOpen(this.clearCache)
      });
    }
    for (let i: number = 1; i <= this.currentMonth; i++) {
      this.lastMonths.push(i);
    }
  }

  ngOnInit() {
  }

  public modalOpen(modalBasic: any) {
    if (this._utilsService.themeConfiguration.maintenance_start) {
      this.formGroup.patchValue({
        hour_from: {
          hour: moment(this._utilsService.themeConfiguration.maintenance_start).hours(),
          minute: moment(this._utilsService.themeConfiguration.maintenance_start).minute()
        }
      });
    }
    if (this._utilsService.themeConfiguration.maintenance_end) {
      this.formGroup.patchValue({
        hour_to: {
          hour: moment(this._utilsService.themeConfiguration.maintenance_end).hours(),
          minute: moment(this._utilsService.themeConfiguration.maintenance_end).minute()
        }
      });
    }

    this.optionFrom = {
      altFormat: "d/m/Y",
      defaultDate: this._utilsService.themeConfiguration.maintenance_start,
      locale: Italian.it,
      altInput: true,
      utc: true,
      disableMobile: true
    };

    const maintenanceStart: any = moment(this._utilsService.themeConfiguration.maintenance_start);
    if (maintenanceStart < moment()) {
      this.optionFrom.defaultDate = moment().toISOString();
    }

    this.optionTo = {
      altFormat: "d/m/Y",
      defaultDate: this._utilsService.themeConfiguration.maintenance_end,
      locale: Italian.it,
      altInput: true,
      utc: true,
      disableMobile: true
    };

    const maintenanceEnd: any = moment(this._utilsService.themeConfiguration.maintenance_end);
    if (maintenanceEnd < moment()) {
      this.optionTo.defaultDate = moment().toISOString();
    }

    this._modalService.open(modalBasic, {
      size: "md",
      centered: true,
      keyboard: false,
      backdrop: false
    });
  }

  modalClose() {
    this._modalService.dismissAll();
    this.urlClearCache = null;
    this.regenerateInvoiceMonth = moment().get("months") + 1;
    this.formGroup.patchValue({
      day_from: moment(),
      day_to: moment(),
      hour_from: {
        hour: 9,
        minute: 0
      },
      hour_to: {
        hour: 10,
        minute: 0
      }
    });
  }

  async setMaintenance() {
    if (!this._authService.hasCapability("manage_platform_maintenance")) {
      window.history.back();
      return false;
    }
    const hourFrom: any = this.formGroup.value.hour_from;
    const hourTo: any = this.formGroup.value.hour_to;
    if (hourFrom.hour > 23 || hourTo.hour > 23) {
      await this._utilsService.showSWALError({ text: "ERROR_DATE_REQUESTED" });
      return false;
    }
    const dayFrom: any = moment(this.formGroup.value.day_from[0]);
    dayFrom.set("hour", hourFrom.hour);
    dayFrom.set("minute", hourFrom.minute);

    const dayTo: any = moment(this.formGroup.value.day_to[0]);
    dayTo.set("hour", hourTo.hour);
    dayTo.set("minute", hourTo.minute);

    if (dayTo < dayFrom) {
      await this._utilsService.showSWALError({ text: "ERROR_DATE_REQUESTED" });
      return false;
    }

    const maintenanceStart: any = moment(dayFrom).format("YYYY-MM-DD HH:mm:00");
    const maintenanceEnd = moment(dayTo).format("YYYY-MM-DD HH:mm:00");

    this._utilsService.updateOption("maintenance_start", maintenanceStart);
    this._utilsService.updateOption("maintenance_end", maintenanceEnd);
  }

  async clearTheCache() {
    if (!this._authService.hasCapability("manage_platform_cache")) {
      window.history.back();
      return false;
    }
    let url: string = this.urlClearCache;
    if (!!url) {
      url = url.trim();
    }
    if (!url) {
      await this._utilsService.showSWALError({ text: "ERROR_URL_CLEAR_CACHE_EMPTY" });
      return false;
    }
    url = `${url}?nocache=1`;
    this.isSubmitting = true;
    await this._utilsService
      .basic_get(url)
      .then(() => {
        this.modalClose();
        this._utilsService.showToastrSuccess("SUCCESS_CLEAR_CACHE");
        this.isSubmitting = false;
      })
      .catch(() => {
        this._utilsService.showToastrError("ERROR_CLEAR_CACHE");
        this.isSubmitting = false;
      });
  }

  formatLabelMonth(month) {
    const date = moment();
    date.set("month", month - 1);
    return `${date.format("MMMM")} ${this.currentYear}`;
  }

  onSearchFeatureOption() {
    const optionsLinks: any = document.querySelectorAll("#cards-container .card-body a");
    const searchFeaturOption: string = this.searchFeaturOption.toLowerCase();

    optionsLinks.forEach((option: any) => {
      option.classList.remove("is-search-result");
    });

    if (this.searchFeaturOption.length > 0) {
      optionsLinks.forEach((option: any) => {
        if (option.innerText.toLowerCase().includes(searchFeaturOption)) {
          option.classList.add("is-search-result");
        }
      });
    }
  }

  reloadAnalytics() {
    this._utilsService.showLoading();
    return this._httpClient.put(
      `/commission/massive-reload-analytics/${this.monthToReload.toString().padStart(2, "0")}/${this.yearToReload}`,
      {},
    )
      .pipe(
        timeout(900000),
        tap(() => {
          this._modalService.dismissAll();
          this._utilsService.hideLoading();
          return this._utilsService.showToastrSuccess("SUCCESS_REGENERATING_ANALYTICS");
        }
        ),
        catchError((error: any) => {
          console.error(error);
          this._utilsService.hideLoading();
          return this._utilsService.showToastrError("ERROR_REGENERATING_ANALYTICS");
        })
      ).subscribe();
  }
}
